import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// eslint-disable-next-line
import styled from 'styled-components/macro';

import { connect } from 'react-redux';
import Logs from './logs';
import InstanceSizes from './instanceSizes';
import Documentation from './documentation';
import WPPostmant from './wp_postman';
import InstagramDoc from './instagram_doc';
import Webhook from './webhook';
import Script from './script';
import Dialogflow from './dialogflow-integration';
import GroupActions from './group_actions';
import GroupInfo from './group_info';
import LogoutInfo from './logout_info';

const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product.maytapi });

const Header = (props) => (
	//<Page flex header={<AccountProgress title="Developers" icon="code"></AccountProgress>}>

	<div
		css={`
			display: flex;
			padding: 12px;
			width: 100%;
			flex-direction: column;
			.ui.bottom.attached {
				height: 100%;
				> div {
					height: 100%;
					overflow: auto;
				}
			}
		`}
	>
		<Switch>
			<Route path="/developers/documentation" component={Documentation} />
			<Route path="/developers/wp_postman_documentation" component={WPPostmant} />
			<Route path="/developers/instagram_documentation" component={InstagramDoc} />
			<Route path="/developers/token" component={Script} />
			<Route path="/developers/logs" component={Logs} />
			<Route path="/developers/instance-status" component={InstanceSizes} />
			<Route path="/developers/webhook" component={Webhook} />
			<Route path="/developers/dialogflow-integration" component={Dialogflow} />
			<Route path="/developers/group_action_logs" component={GroupActions} />
			<Route path="/developers/group_info" component={GroupInfo} />
			<Route path="/developers/logout_info" component={LogoutInfo} />
			<Redirect to="/developers/documentation" />
		</Switch>
	</div>
);

export default connect(stateToProps)(Header);
